var menuBtn = document.getElementById('featurePageNavigationBtn');
var navigation = document.getElementById('featureNavigationMenu');
var btnIcon = document.querySelector('.feature-page__navigation-btn-icon');

if(menuBtn) {
    menuBtn.addEventListener('click', function() {
        navigation.classList.toggle('feature-page__navigation-list--mobile');
        btnIcon.classList.toggle('feature-page__navigation-btn-icon--closed');
    })
}


var menuBtnDynamic = document.getElementById('featurePageDynamicNavigationBtn');
var navigationDynamic = document.getElementById('featureDynamicNavigationMenu');
var btnIconDynamic = document.querySelector('.feature-navigation__btn-icon');

if(menuBtnDynamic) {
    menuBtnDynamic.addEventListener('click', function() {
        console.log('click');
        navigationDynamic.classList.toggle('feature-navigation__list--mobile');
        btnIconDynamic.classList.toggle('feature-navigation__btn-icon--closed');
    })
}
